export const getWeststeiermarkData = () => ({
  name: "Weststeiermark",
  region: "Steiermark",
  country: "Autriche",
  description: "Weststeiermark est une sous-région viticole occidentale de Steiermark, produisant des vins rouges et blancs équilibrés. Cette région bénéficie d'un climat continental tempéré, créant des conditions favorables pour une viticulture diversifiée.",
  type: "subregion",
  area: "600 ha",
  production: "0.04 million hectolitres",
  climate: "Climat continental tempéré, étés modérés et hivers froids",
  soil: "Sols argileux, calcaires, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental tempéré, étés modérés et hivers froids",
    soil: "Sols argileux, calcaires, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements modérés, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs secs et équilibrés, avec une acidité modérée",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Weststeiermark remonte à l'époque romaine. La région a développé une réputation pour ses vins équilibrés, notamment les vins rouges et blancs. Aujourd'hui, Weststeiermark est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine autrichienne traditionnelle, viandes, fromages affinés, plats locaux",
  grapeVarieties: [
    {
      name: "Blaufränkisch",
      percentage: "35%",
      description: "Cépage rouge principal, produisant des vins légers et fruités",
      characteristics: "Léger, fruité, tanins fins",
      wineStyles: "Sec, léger, fruité"
    },
    {
      name: "Zweigelt",
      percentage: "25%",
      description: "Cépage rouge produisant des vins légers et aromatiques",
      characteristics: "Léger, aromatique, tanins fins",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "20%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "15%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Weststeiermark", x: 15.3, y: 47.1, color: "#6d2c7a", size: 2 }
  ]
}); 